// // 顶部菜单
// if ($(window).scrollTop() > 0) {
// 	$(".home_logo").addClass("NavBg");
// }
// else {
// 	$(".home_logo").removeClass("NavBg");
// }  
// $(window).scroll(function(){                
// 	if ($(window).scrollTop() > 0) {
// 		$(".home_logo").addClass("NavBg");
// 	}
// 	else {
// 		$(".home_logo").removeClass("NavBg");
// 	}  
// });

// 弹出窗口
$(function(){
	$(".lawyer_btn .dc").click(function(){
		$(".black_bg").show();
		$(".qrcode_share_box").show();
	})
	$(".show_wechat").click(function(){
	$(".black_bg").show();
	$(".wechat_box").show();
	})
	//   $(".close_ewm_box").click(function(){
	// 	$(".black_bg").hide();
	// 	$(".ewm_box").hide();
	//   })
	//   $(".black_bg").click(function () {
	// 	  $(".black_bg").hide();
	// 	  $(".ewm_box").hide();
	// 	  $(".search_box").hide();
	// 	  $(".qrcode_box").hide();
	// 	  $(".wechat_box").hide();
	// 	  $(".qrcode_share_box").hide();
	//   })
})

// // 顶部二维码
// $(document).ready(function () {
// 	var qcode = $("#qrcodetop");
// 	if (qcode.html() == undefined || qcode.html() == "") {
// 		var qrcodecontext = document.location.href;
// 		qrcodecontext = qrcodecontext.substring(0, 4).toLowerCase() == "http" ? qrcodecontext : "http://" + qrcodecontext;
// 		var qrnode = new QRCode({ correctLevel: 0, text: qrcodecontext, width: 140, height: 140, background: "#fff", foreground: "#000" });
// 		qcode.html(qrnode);
// 	}
// });

// // 人员部二维码
// $(document).ready(function () {
// 	var qcode = $("#qrcodelawyer");
// 	if (qcode.html() == undefined || qcode.html() == "") {
// 		var qrcodecontext = document.location.href;
// 		qrcodecontext = qrcodecontext.substring(0, 4).toLowerCase() == "http" ? qrcodecontext : "http://" + qrcodecontext;
// 		var qrnode = new QRCode({ correctLevel: 0, text: qrcodecontext, width: 140, height: 140, background: "#fff", foreground: "#000" });
// 		qcode.html(qrnode);
// 	}
// });

// // 新闻二维码
// $(document).ready(function () {
// 	var qcode = $("#qrcode");
// 	if (qcode.html() == undefined || qcode.html() == "") {
// 		var qrcodecontext = document.location.href;
// 		qrcodecontext = qrcodecontext.substring(0, 4).toLowerCase() == "http" ? qrcodecontext : "http://" + qrcodecontext;
// 		var qrnode = new QRCode({ correctLevel: 0, text: qrcodecontext, width: 100, height: 100, background: "#fff", foreground: "#000" });
// 		qcode.html(qrnode);
// 	}
// });

// // 平滑滚动
// $(document).ready(function(){
// 	$(".go_down_btn").click(function(){//可替换为：$(".yjw").click(function(){
// 		var href = $(this).attr("href");
// 		var pos = $(href).offset().top - 0;
// 		$("html,body").animate({scrollTop: pos}, 1000);
// 		return false;
// 	});
// });

if ((/Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i).test(navigator.userAgent || navigator.vendor || window.opera)) {
	$('div').removeClass('parallax');
}
	